import React from 'react';
import { BlogPostLayout } from '../blog/BlogPostLayout';
import { BLOG_AUTHORS } from '../blog/authors';
import { BLOG_POSTS } from '../blog/postsMeta';
import { WHY_I_CREATED_ARTICLE_BLOCKS } from '../blog/postContent/whyICreatedOrivonaiBlocks';

const TOKENS = { pinkD: '#993556' };

export default function BlogWhyICreatedOrivonai() {
  const post = BLOG_POSTS['why-i-created-orivonai'];
  const author = BLOG_AUTHORS[post.authorId];

  const heading = (
    <>
      Why I Created{' '}
      <em style={{ fontFamily: "'Playfair Display', Georgia, serif", fontStyle: 'italic', color: TOKENS.pinkD }}>
        OrivonAI
      </em>
    </>
  );

  return <BlogPostLayout post={post} author={author} heading={heading} blocks={WHY_I_CREATED_ARTICLE_BLOCKS} />;
}
